import { buildPath } from "../../../helpers/string";
import { PermissionEnum } from "../../../modules/permission/enum";
import { root } from "./root";

export const organizations = {
  path: "organizations",
  getLink: () => buildPath([root.path, organizations.path]),
  permissions: [
    PermissionEnum.ORGANIZATION_MANAGEMENT_ACCESS,
    PermissionEnum.REVIEW_APPLICATIONS_ACCESS,
    PermissionEnum.INVESTIGATE_APPLICATIONS_ACCESS,
  ],
  organizationDetails: {
    path: ":organizationId",
    getLink: (organizationId: string | number) => buildPath([organizations.path, organizationId.toString()]),
    permissions: [
      PermissionEnum.ORGANIZATION_MANAGEMENT_ACCESS,
      PermissionEnum.REVIEW_APPLICATIONS_ACCESS,
      PermissionEnum.INVESTIGATE_APPLICATIONS_ACCESS,
    ],
  },
};
